import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Clock = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsxs("g", { fillRule: "evenodd", children: [_jsx("path", { d: "M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m0 2.5c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10" }), _jsx("path", { d: "M10 4.583c.69 0 1.25.56 1.25 1.25V10a1.25 1.25 0 1 1-2.5 0V5.833c0-.69.56-1.25 1.25-1.25" }), _jsx("path", { d: "M15.417 10c0 .69-.56 1.25-1.25 1.25H10a1.25 1.25 0 1 1 0-2.5h4.167c.69 0 1.25.56 1.25 1.25" })] }) }));
});
Clock.displayName = 'Clock';
Clock.__iconComponentType = 'standard';
export default Clock;
//# sourceMappingURL=Clock.js.map